/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum BadgeAntennaBType {
    PEDESTRIAN_MODULE = 'pedestrianModule'
}


export function instanceOfBadgeAntennaBType(value: any): boolean {
    for (const key in BadgeAntennaBType) {
        if (Object.prototype.hasOwnProperty.call(BadgeAntennaBType, key)) {
            if (BadgeAntennaBType[key as keyof typeof BadgeAntennaBType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function BadgeAntennaBTypeFromJSON(json: any): BadgeAntennaBType {
    return BadgeAntennaBTypeFromJSONTyped(json, false);
}

export function BadgeAntennaBTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): BadgeAntennaBType {
    return json as BadgeAntennaBType;
}

export function BadgeAntennaBTypeToJSON(value?: BadgeAntennaBType | null): any {
    return value as any;
}

export function BadgeAntennaBTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): BadgeAntennaBType {
    return value as BadgeAntennaBType;
}

